import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["type", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_3 = { key: 0 }

import { computed } from 'vue'

interface Props {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger'
  size?: 'sm' | 'md' | 'lg' | 'xl'
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  loading?: boolean
  loadingText?: string
  fullWidth?: boolean
  customClass?: string
}

interface Emits {
  (e: 'click', event: MouseEvent): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseButton',
  props: {
    variant: { default: 'primary' },
    size: { default: 'md' },
    type: { default: 'button' },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    loadingText: {},
    fullWidth: { type: Boolean, default: false },
    customClass: { default: '' }
  },
  emits: ["click"],
  setup(__props: any) {

const props = __props



const buttonClasses = computed(() => {
  const baseClasses = [
    'inline-flex items-center justify-center font-medium rounded-xl transition-all duration-200',
    'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500',
    'disabled:opacity-50 disabled:cursor-not-allowed',
    props.fullWidth && 'w-full'
  ]

  // Size classes
  const sizeClasses = {
    sm: 'px-3 py-2 text-sm',
    md: 'px-4 py-2.5 text-sm',
    lg: 'px-6 py-3 text-base',
    xl: 'px-8 py-4 text-lg'
  }

  // Variant classes
  const variantClasses = {
    primary: 'bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white shadow-lg hover:shadow-xl',
    secondary: 'bg-gray-600 hover:bg-gray-700 text-white shadow-lg hover:shadow-xl',
    outline: 'border-2 border-purple-600 text-purple-600 hover:bg-purple-600 hover:text-white',
    ghost: 'text-purple-600 hover:bg-purple-50 dark:hover:bg-purple-900/20',
    danger: 'bg-red-600 hover:bg-red-700 text-white shadow-lg hover:shadow-xl'
  }

  return [
    ...baseClasses,
    sizeClasses[props.size],
    variantClasses[props.variant],
    props.customClass
  ].filter(Boolean)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: _ctx.type,
    disabled: _ctx.disabled || _ctx.loading,
    class: _normalizeClass(buttonClasses.value),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', $event)))
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent mr-2" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.loadingText || 'Loading...'), 1)
        ]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _renderSlot(_ctx.$slots, "icon-left"),
          (_ctx.$slots.default)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _renderSlot(_ctx.$slots, "default")
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "icon-right")
        ], 64))
  ], 10, _hoisted_1))
}
}

})